import { css } from '@emotion/css'
import colors from '@styles/colors';
import { mobileOnly, tabletLandscapeUp } from '@v2/styles/breakpoints';

export default {
    filterContainer: css({
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        backgroundColor: colors.WHITE,
        zIndex: 1,
        [mobileOnly]: {
            flexDirection: 'column',
            paddingTop: 20,
        },
        '.select-dropdown': {
            minWidth: 160,
            [mobileOnly]: {
                width: '100%',
            }
        },
        '.category-title': {
            display: 'none',
            padding: 0,
            whiteSpace: 'pre',
            marginBottom: '0px !important',
            [tabletLandscapeUp]: {
                display: 'block',
            },
            'h2': {
                marginBottom: '0px !important',
            },
        },
        '.filter-separator': {
            height: 2,
            backgroundColor: colors.BLUE_EXTRA_LIGHT,
            width: '100%',
            margin: '0 20px',
            position: 'relative',
            '> div': {
                display: 'none',
                [mobileOnly]: {
                    backgroundColor: colors.WHITE,
                    display: 'inline-flex',
                    padding: '10px 16px',
                    zIndex: 3,
                    fontWeight: 600,
                    fontSize: 22,
                    lineHeight: '135%',
                    letterSpacing: '0.02em',
                    position: 'absolute',
                    left: '50%',
                    top: '-50%',
                    transform: 'translate(-50%, -50%)',
                }
            }
        },
        '.select__control': {
            marginTop: 0,
        },
        '.filter-actions': {
            display: 'flex',
            flexDirection: 'row',

            [mobileOnly]: {
                width: '100%',
                marginTop: 40,
                flexWrap: 'nowrap',
                justifyContent: 'space-between',
                alignItems: 'center',
                alignContent: 'center',
            },

            'button.reset': {
                padding: 0,
                border: 0,
                marginRight: 25,
                textTransform: 'capitalize',
                fontSize: 15,
                lineHeight: '135%',
                letterSpacing: '0.02em',
                display: 'block',

                [mobileOnly]: {
                    display: 'none',
                },

                '&.mobile': {
                    marginLeft: 25,
                    marginRight: 0,
                    display: 'none',
                    [mobileOnly]: {
                        display: 'block',
                    }
                }
            }
        }
    })
};
